module.exports = __webpack_public_path__ + "static/img/logo.c6706727.png";